const state = { email: null }

const getters = {
  email(state) {
    return state.email
  },
}

const mutations = {
  SET(state, email) {
    state.email = email
  },
  CLEAR(state) {
    state.email = null
  },
}

const actions = {
  signUp({ commit }, email) {
    commit('SET', email)
  },
  initialize({ commit }) {
    commit('CLEAR')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
